const ACTIONS = {
  DEPOSIT: 'DEPOSIT',
};

export { ACTIONS };
